<template>
  <div class="notifications card text-md" id="tpl_pmSteeringAlert_popup">
    <div class="cursor-pointer absolute right-5 hover:text-[var(--color-orange)]" id="btn_close">
      <i @click.prevent="deactivate()">
        <font-awesome-icon
          icon="fa-xmark"
        />
      </i>
    </div>
    <div class="text-justify p-5">
      <div class="flex break-words items-start">
        <font-awesome-icon
          class="w-12 h-12"
          v-if="notification.content.icon"
          :icon="notification.content.icon"
        ></font-awesome-icon>
        <h3 v-if="notification.content.header && notification.content.header[lang]" class="pl-3">
          <span id="txt_pmSteeringAlertHeader">
            {{ notification.content.header[lang] }}
          </span>
        </h3>
      </div>
      <div
        v-if="notification.content.text && notification.content.text[lang]"
        class="flex break-normal"
      >
        <h4 id="tpl_pmSteeringAlert_text" class="break-normal">
          {{ notification.content.text[lang] }}
        </h4>
      </div>
    </div>
    <div class="flex justify-end">
      <button
        v-if="notification.content.positiveButton && notification.content.positiveButton[lang]"
        type="button"
        class="block mr-5 ml-auto mt-4 py-3 px-9 rounded-full text-lg bg-[var(--color-orange)]"
        name="regist"
        id="btn_regist"
        @click.prevent="navigate"
      >
        {{ notification.content.positiveButton[lang] }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'PmSteeringAlertNotificationComponent',
  props: ['notification'],
  computed: {
    lang() {
      return this.$i18n?.locale || 'en';
    },
    projectId() {
      const value = this.notification?.content?.projectId;
      return value ? String(value) : null;
    },
    routePath() {
      const value = this.notification?.content?.routePath;
      if (typeof value === 'string' && value.startsWith('/')) {
        return value;
      }
      const tenantUrl = this.notification?.content?.tenantUrl;
      if (typeof tenantUrl !== 'string') {
        return null;
      }
      if (tenantUrl.startsWith('/')) {
        return tenantUrl;
      }
      try {
        const url = new URL(tenantUrl);
        return `${url.pathname}${url.search}`;
      } catch {
        return null;
      }
    },
  },
  methods: {
    ...mapActions('pmProject', ['changeUserProjectContext']),
    deactivate() {
      this.$store.dispatch('deactivatePopUp', this.notification._id);
    },
    async navigate() {
      const popupId = this.notification._id;
      try {
        if (this.projectId) {
          await this.changeUserProjectContext(this.projectId);
        }
        if (this.routePath) {
          await this.$router.push(this.routePath);
        }
      } finally {
        await this.$store.dispatch('deactivatePopUp', popupId);
      }
    },
  },
};
</script>
